import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PumpGlyph = /*#__PURE__*/createElement("g", {
  id: "pump"
}, /*#__PURE__*/createElement("path", {
  d: "M42 14.3c-15.3 0-27.7 12.4-27.7 27.7 0 15.3 12.4 27.7 27.7 27.7 15.3 0 27.7-12.4 27.7-27.7 0-15.3-12.4-27.7-27.7-27.7zm24.8 26.8-24-24c13.1.5 23.6 11 24 24zm-49.6.9c0-12.7 9.6-23.2 21.8-24.6L63.7 42 39 66.6C26.7 65.2 17.2 54.7 17.2 42zm25.7 24.8 24-24c-.5 13.1-11 23.6-24 24z"
}));
const Pump = createSvg({
  name: 'pump',
  path: PumpGlyph
});

export default Pump;
export { PumpGlyph };
